import { ExperienceTemplateRenderer, getChildByName, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { ViewExtraLarge, ViewLarge, Viewport } from '@shared-ui/viewport-context';

import { FitContent, UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkScrollable } from 'uitk-react-scrollable';

export const SRPLayout: React.FC<TemplateComponentProps> = props => {
  const { templateComponent } = props;

  const childrenForArea = React.useCallback(
    areaName => {
      const area = getChildByName(templateComponent, areaName);

      return area && area.children ? area.children : [];
    },
    [templateComponent]
  );

  return (
    <ErrorBoundary label="srp.page.layout">
      <UitkLayoutGrid
        areas={{
          small: ['header', 'main'],
          large: ['header header', 'main map'],
          /* eslint-disable camelcase */
          extra_large: ['header header header', 'main map ad'],
        }}
        rows={['auto', '1fr']}
        columns={{
          large: [FitContent('180x'), '1fr'],
          /* eslint-disable camelcase */
          extra_large: [FitContent('180x'), '1fr', '40x'],
        }}
        blockSize={'100vb'}
        space={{ column: 'six' }}
      >
        <UitkLayoutGridItem area={'header'}>
          <header data-stid="header-error-boundary">
            <ErrorBoundary label="main-search-result-list-error-boundary">
              <ExperienceTemplateRenderer templateComponents={childrenForArea('header-area')} />
            </ErrorBoundary>
          </header>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem area={'main'}>
          <UitkScrollable direction="vertical">
            <main data-stid="search-results-list">
              <ErrorBoundary label="main-search-result-list-error-boundary">
                <ExperienceTemplateRenderer templateComponents={childrenForArea('main-area')} />
              </ErrorBoundary>
            </main>
          </UitkScrollable>
        </UitkLayoutGridItem>
        <Viewport>
          <ViewLarge>
            <UitkLayoutGridItem area={'map'}>
              <aside data-stid="dynamic-search-map">
                <ErrorBoundary label="dynamic-search-map-error-boundary">
                  <ExperienceTemplateRenderer templateComponents={childrenForArea('map-area')} />
                </ErrorBoundary>
              </aside>
            </UitkLayoutGridItem>
          </ViewLarge>
        </Viewport>
        <Viewport>
          <ViewExtraLarge>
            <UitkLayoutGridItem area={'ad'}>
              <section data-stid="meso-ad">
                <ErrorBoundary label="meso-ad-error-boundary">
                  <ExperienceTemplateRenderer templateComponents={childrenForArea('ad-area')} />
                </ErrorBoundary>
              </section>
            </UitkLayoutGridItem>
          </ViewExtraLarge>
        </Viewport>
      </UitkLayoutGrid>
    </ErrorBoundary>
  );
};
